import { render, staticRenderFns } from "./StatisticHeader.vue?vue&type=template&id=1c7acf9f&"
import script from "./StatisticHeader.vue?vue&type=script&lang=js&"
export * from "./StatisticHeader.vue?vue&type=script&lang=js&"
import style0 from "./StatisticHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports